// @ts-nocheck
import { useEffect, useState } from 'react';

import { ArrowSquareOut } from '@phosphor-icons/react';
import { Text, XStack, YStack } from 'tamagui';

import { Header, Footer } from '../components/landing';

export default function AboutPage() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <YStack backgroundColor="$background" minHeight="100vh">
      <Header />

      <YStack paddingTop={140} paddingHorizontal="$5" gap="$8" paddingBottom={80}>
        <YStack maxWidth={800} alignSelf="center" width="100%">
          {/* Page header */}
          <YStack marginBottom={48}>
            <Text
              fontSize={isMobile ? 30 : 44}
              fontWeight="700"
              letterSpacing={-1.5}
              lineHeight={isMobile ? 36 : 52}
              color="$color12"
            >
              About
            </Text>
          </YStack>

          <YStack gap="$6">
            <Text fontSize={16} color="$color10" lineHeight={26}>
              Torch is built by SID Technologies. We build infrastructure and applications for
              modern financial and AI-native workflows.
            </Text>

            <YStack gap="$4">
              <XStack
                gap="$2"
                alignItems="center"
                cursor="pointer"
                onPress={() => window.open('https://romans.dev/about', '_blank')}
                hoverStyle={{ opacity: 0.8 }}
              >
                <Text fontSize={16} color="#ededed" fontWeight="500">
                  About SID Technologies
                </Text>
                <ArrowSquareOut size={16} color="#ededed" />
              </XStack>
              <Text fontSize={14} color="$color9" lineHeight={22}>
                The full company story, team, and product portfolio.
              </Text>
            </YStack>

            <YStack gap="$4">
              <XStack
                gap="$2"
                alignItems="center"
                cursor="pointer"
                onPress={() => window.open('https://romans.dev', '_blank')}
                hoverStyle={{ opacity: 0.8 }}
              >
                <Text fontSize={16} color="#ededed" fontWeight="500">
                  SID Product Portfolio
                </Text>
                <ArrowSquareOut size={16} color="#ededed" />
              </XStack>
              <Text fontSize={14} color="$color9" lineHeight={22}>
                Explore the full suite of SID products.
              </Text>
            </YStack>

            <YStack
              marginTop="$4"
              padding="$5"
              borderRadius="$4"
              borderWidth={1}
              borderColor="$color4"
              backgroundColor="$color2"
              gap="$2"
            >
              <Text fontSize={14} fontWeight="600" color="$color11">
                Contact
              </Text>
              <Text
                fontSize={15}
                color="#ededed"
                cursor="pointer"
                onPress={() => window.open('mailto:dans@romans.dev')}
                hoverStyle={{ opacity: 0.8 }}
              >
                dans@romans.dev
              </Text>
            </YStack>
          </YStack>
        </YStack>
      </YStack>

      <Footer />
    </YStack>
  );
}
